var getAccountRecoveryAction = function (actions) {
    return actions.find(function (a) {
        return a.actionType === 'payload' &&
            a.payload.account_recovery_step_key === 'account_recovery';
    });
};
var doesFormHaveField = function (template, key) {
    return template.fields.find(function (f) { return f.key === key; });
};
function useJobFormError(linkApiResponse) {
    if (linkApiResponse.responseType !== 'next_with_error')
        return null;
    if (linkApiResponse.template.templateType !== 'form')
        return null;
    var standardReturnValue = { errorMessage: linkApiResponse.error.message };
    if (linkApiResponse.error.code !== 'invalidCredentials')
        return standardReturnValue;
    var accountRecoveryAction = getAccountRecoveryAction(linkApiResponse.template.actions);
    if (!accountRecoveryAction)
        return standardReturnValue;
    var hasUsernameField = doesFormHaveField(linkApiResponse.template, 'username');
    var hasPasswordField = doesFormHaveField(linkApiResponse.template, 'password');
    if (!hasUsernameField && !hasPasswordField)
        return standardReturnValue;
    if (hasUsernameField && hasPasswordField) {
        return {
            errorMessage: 'Incorrect username or password.',
            accountRecoveryAction: accountRecoveryAction,
            actionLabel: 'Help me log in',
        };
    }
    if (hasUsernameField)
        return {
            errorMessage: 'Unknown username.',
            accountRecoveryAction: accountRecoveryAction,
            actionLabel: 'Recover username',
        };
    return {
        errorMessage: 'Incorrect password.',
        accountRecoveryAction: accountRecoveryAction,
        actionLabel: 'Reset password',
    };
}
export default useJobFormError;
